export default "__VITE_ASSET__QzLWcgp0__"